import script from "./StoryButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryButton.vue?vue&type=script&lang=js"
export * from "./StoryButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/StoryButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3491060f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3491060f', __exports__)) {
    api.reload('3491060f', __exports__)
  }
  
}


export default __exports__